/**
 * Returns only Ecuador's calling code option.
 * The platform serves Ecuador exclusively, so no other country is offered.
 */
export function getCountryCodeOptions() {
  return [{ code: "EC", country: "EC", callingCode: "+593" }];
}

/**
 * Get country calling code by country code.
 * Only Ecuador (+593) is supported — returns "+593" for any input.
 */
export function getCallingCode(_countryCode: string): string {
  return "+593";
}

/**
 * Get country code by calling code (e.g., "+593" → "EC").
 * Returns the first matching country code.
 */
export function getCountryByCallingCode(callingCode: string): string | null {
  const options = getCountryCodeOptions();
  const match = options.find((opt) => opt.callingCode === callingCode);
  return match?.code ?? null;
}
